// Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.

import React from "react";
import { getAuthType } from "../../../configurations";
import { AuthType } from "../../../enums";
import { AuthState } from "../../../types";
import { CognitoAuthStrategy } from "../cognito/CognitoAuthStrategy";
import { SSOAuthStrategy } from "../sso/SSOAuthStrategy";
import SignInPage from "../signIn/SignInPage";
import EUCSignInPage from "../signIn/EUCSignInPage";
import { getLegacyFlag } from "../../../utils/toolbarItemUtils";

interface Props {
  onSignIn: (authState: AuthState) => void;
}

const Authentication = (props: Props): JSX.Element => {
  const { onSignIn } = props;
  const authType = getAuthType();

  let authStrategy;
  switch (authType) {
    case AuthType.STANDARD: {
      authStrategy = new CognitoAuthStrategy();
      break;
    }
    case AuthType.IAM_IDENTITY_CENTER: {
      authStrategy = new SSOAuthStrategy();
      break;
    }
  }

  return getLegacyFlag() ? (
    <SignInPage onSignIn={onSignIn} authStrategy={authStrategy} />
  ) : (
    <EUCSignInPage onSignIn={onSignIn} authStrategy={authStrategy} />
  );
};

export default Authentication;
